import React, {useState, useEffect} from 'react';
import {isEmpty} from 'lodash';
import VehicleChangeWatcher from "../components/GroupItems/VehicleChangeWatcher";
import VehicleChangeHandler from "../logic/VehicleChangeHandler";
import {getDispatch} from "../../Utility/ReduxHelper";
import {parsePageType} from "../logic/productGroup";

/**
 * 2026-07 cleaned up, no longer uses GroupPageType object
 *
 * 2025-02 extracted from GroupProductsContainer, a class that did far too much.
 *
 * @param productGroup
 * @param customerVehicle
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function GroupVehicleWatcher({
  productGroup = {}, customerVehicle,
}) {

  // what fields do we care about?  [ id, [fitment, [lloyd_unique]]]
  const [watchedFields, setWatchedFields] = useState(null);

  useEffect(() => {
    let pt = parsePageType(productGroup.pageType);
    let ff = pt.watchedFields;
    setWatchedFields(ff);
  }, [productGroup]);

  const handleVehicleChange = (changes) => {
    const handler = new VehicleChangeHandler({
      productGroup, changes, customerVehicle, watchedFields,
    });

    handler.call({dispatch: getDispatch()});
  }

  if (isEmpty(watchedFields)) return null;

  // 2026 TODO fix this legacy component
  return <VehicleChangeWatcher
    watchedFields={watchedFields}
    customerVehicle={customerVehicle}
    onVehicleChanged={handleVehicleChange}/>

}
